<template>
	<router-link :to="`/podcasts/${podcast.id}`" class="flex flex-row items-center gap-3 hover:bg-light-blue p-2 -m-2 rounded-lg transition">
		<figure class="w-24 rounded-md overflow-hidden flex-shrink-0">
			<img :src="podcast.icon" :alt="podcast.name" class="w-full h-full object-cover" />
		</figure>
		<div class="flex-1">
			<h3 class="font-bold text-lg leading-tight">{{ podcast.name }}</h3>
			<p class="line-clamp-2 text-sm">{{ $sanitize(podcast.description) }}</p>
		</div>
	</router-link>
</template>

<script setup>
import { defineProps } from 'vue'

// Deklarera vilka data komponenten behöver ta emot
defineProps({
	podcast: {
		type: Object,
		required: true
	}
})
</script>
